// Keeps Image refs so browser memory cache survives gantt smart_rendering DOM recycle
const imageCache = new Map();

const DEFAULT_AVATAR_SUFFIX = '/imgs/default/default-ava.svg';

let listenersReady = false;

export function getResourcePhotoUrl(resource) {
  // new / unassigned resources may have no photo yet
  const photo = resource.photo || resource.resourcePhoto;

  if (photo) {
    return photo;
  }

  return `${GT.cdn}${DEFAULT_AVATAR_SUFFIX}`;
}

export function preloadResourcePhoto(url) {
  if (!url || imageCache.has(url)) {
    return;
  }

  const img = new Image();

  img.decoding = 'async';
  img.src = url;
  imageCache.set(url, img);
}

export function forgetResourcePhoto(url) {
  if (!url || url.endsWith(DEFAULT_AVATAR_SUFFIX)) {
    return;
  }

  imageCache.delete(url);
}

export function preloadResourcePhotos(resources) {
  if (!resources?.length) {
    return;
  }

  resources.forEach(resource => {
    preloadResourcePhoto(getResourcePhotoUrl(resource));
  });
}

// After collaboration / profile photo change: warm cache and patch visible grid icons
export function applyResourcePhotoUpdate({ resourceId, photoUrl, previousPhotoUrl }) {
  if (previousPhotoUrl && previousPhotoUrl !== photoUrl) {
    forgetResourcePhoto(previousPhotoUrl);
  }

  if (photoUrl) {
    preloadResourcePhoto(photoUrl);
  }

  if (!resourceId || !photoUrl) {
    return;
  }

  const testId = `gp_autotest_gantt_cell_resource_icon_${resourceId}`;

  document.querySelectorAll(`[data-testid="${testId}"]`).forEach(el => {
    el.style.backgroundImage = `url(${photoUrl})`;
  });
}

export function initResourcePhotoPreloadListeners(appInstance, store) {
  if (listenersReady) {
    return;
  }

  listenersReady = true;

  appInstance.on('userAvatar:update', photoUrl => {
    const resource = store.getters['resourcesModel/getResourceByUserId'](user.id);
    const previousPhotoUrl = resource?.photo !== photoUrl ? resource?.photo : undefined;

    applyResourcePhotoUpdate({
      resourceId: resource?.id,
      photoUrl,
      previousPhotoUrl,
    });
  });
}
